module.exports = __webpack_public_path__ + "media/images/icons/icon_contact_hover-c42aaf554a2adeb9df952185a10d5ad2.svg";